import React, { useState, useEffect, useRef } from "react";
import { authActions } from "../../../redux-store";
import { useDispatch } from "react-redux";
import backend from "../../../api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { motion, easeOut, AnimatePresence } from "framer-motion";
import Classes from "./Auth.module.css";
import CryptoJS from "crypto-js";
import { useSelector } from "react-redux";

const LoadingSpinner = () => (
    <div className="loadingio-spinner-eclipse-nq4q5u6dq7r">
        <div className="ldio-x2uulkbinbj">
            <div></div>
        </div>
    </div>
);

const fadeInLeft = {
    initial: { opacity: 0, x: -10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -10 },
    transition: { duration: 0.5, ease: easeOut, delay: 0.3 },
};

function ManufacturerSignup() {
    const [state, setState] = useState("signup"); // 'signup' | 'verify' | 'createProfile'
    const { user } = useSelector((s) => (s.auth));
    const userId = user?._id

    // basic creds
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setconfirmPassword] = useState("");

    // create profile fields
    const [profileName, setProfileName] = useState("");
    const [profilePhone, setProfilePhone] = useState("");
    const [manufacturerName, setManufacturerName] = useState("");
    const [manufacturerWebsite, setManufacturerWebsite] = useState("");
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState("");

    // ui + errors
    const [loading, setLoading] = useState(false);
    const [incorrectError, setincorrectError] = useState(false);
    const [showEye, setshowEye] = useState(false);
    const [showEye2, setshowEye2] = useState(false);
    const [passwordMatchingError, setpasswordMatchingError] = useState(false);
    const [passwordLengthError, setpasswordLengthError] = useState(false);
    const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [codeSentMsg, setcodeSentMsg] = useState(false);
    const [IncorrectCode, setIncorrectCode] = useState(false);
    const [userCode, setUserCode] = useState("");

    const dispatch = useDispatch();
    const navigateTo = useNavigate();
    const location = useLocation();

    // generate a 4-digit verification code
    const code = Math.floor(Math.random() * 10000).toString();
    const message = `verification code is ${code}`;

    // cleanup preview URL when file changes
    useEffect(() => {
        if (!logoFile) {
            setLogoPreview("");
            return;
        }
        const url = URL.createObjectURL(logoFile);
        setLogoPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [logoFile]);

    const switchToVerify = () => {
        setincorrectError(false);

        if (password !== confirmPassword) {
            setpasswordMatchingError(true);
            setTimeout(() => setpasswordMatchingError(false), 5000);
            return;
        }
        if (password && password.length <= 5) {
            setpasswordLengthError(true);
            setTimeout(() => setpasswordLengthError(false), 10000);
            return;
        }
        sendMail();
    };

    const sendMail = async () => {
        setLoading(true);
        try {
            const encrypted = CryptoJS.AES.encrypt(code, "secret-key").toString();
            sessionStorage.setItem("encryptedData", encrypted);

            const body = { username: "User", email, message };
            const resp = await backend.post("/verify/sendemail", body);

            if (resp.status === 200) {
                setcodeSentMsg(true);
                setTimeout(() => setcodeSentMsg(false), 60000);
                setState("verify");
            } else if (resp.status === 400) {
                setUserAlreadyExistError(true);
                setTimeout(() => setUserAlreadyExistError(false), 10000);
            } else if (resp.status === 500) {
                alert("Server error occurred. Please try again later.");
            } else {
                alert("An unexpected error occurred. Please try again.");
            }
        } catch (error) {
            setUserAlreadyExistError(true);
            setErrorMessage(error?.response?.data?.message);
            setTimeout(() => {
                setUserAlreadyExistError(false);
                setErrorMessage("");
            }, 10000);
        } finally {
            setLoading(false);
        }
    };


    const SignUpHandler = async () => {
        setLoading(true)
        const role = 'manufacturer'
        try {
            if (email != "" && email != null && email != undefined &&
                password != "" && password != null && password != undefined
            ) {
                if (email.includes("@") && password.length > 5) {
                    const isSignup = await dispatch(
                        authActions.signUp(email, password, role)
                    );
                    if (isSignup) {
                        setLoading(false)
                        console.log(isSignup)
                        return true;
                    }
                    if (!isSignup) {
                        setLoading(false)
                        setincorrectError(true);
                        return false;
                    }
                }
                else {
                    setLoading(false)
                    setpasswordLengthError(true);
                    setTimeout(() => {
                        setpasswordLengthError(false);
                    }, 10000);
                    return false;
                }
            } else {
                setLoading(false)
                setpasswordLengthError(true);
                setTimeout(() => {
                    setpasswordLengthError(false);
                }, 10000);
                return false;
            }
        } catch (e) {
            setLoading(false)
            alert("Network Error");
            return false;
        }
    };

    const handleSignUpSubmit = (e) => {
        e.preventDefault();
        if (email?.startsWith("demo.evala")) {
            SignUpHandler();
        } else {
            switchToVerify();
        }
    };

    const onCLickVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        const encryptedDataFromStorage = sessionStorage.getItem("encryptedData");
        if (encryptedDataFromStorage) {
            const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, "secret-key");
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

            if (userCode === decryptedData) {
                setLoading(false);
                const success = await SignUpHandler();
                if (success) {
                    navigateTo('/onboarding/manufacturer');
                }
            } else {
                setIncorrectCode(true);
                setLoading(false);
                setTimeout(() => setIncorrectCode(false), 1000);
            }
        }
    };


    return (
        <>
            <div className={Classes.signUp}>
                {/* LEFT SIDE */}
                <div className={Classes.signUpGridLeft}>
                    <AnimatePresence mode="wait">
                        {/* SIGNUP */}
                        {state === "signup" && (
                            <motion.div key="signup" {...fadeInLeft}>
                                <form
                                    onSubmit={handleSignUpSubmit}
                                    className={Classes.signUpInnerCon}
                                >
                                    <a
                                        href="/"
                                        className={Classes.miniLogo2}
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="logo">
                                            <img src="/assets/images/logo.png" alt="logo" />
                                        </div>
                                    </a>
                                    <h5 className={Classes.heading2}>Sign Up</h5>
                                    <p
                                        className={Classes.subtitle}
                                        style={{ textAlign: "start" }}
                                    >
                                        Reach thousands of designers, showcase your lighting products, and gain valuable insights into buyer behavior
                                    </p>

                                    <input
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        placeholder="Enter your email"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError
                                            ? Classes.inputError
                                            : ""
                                            }`}
                                        style={{ width: "100%" }}
                                    />

                                    <div
                                        className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError ||
                                            passwordMatchingError ||
                                            passwordLengthError
                                            ? Classes.inputError
                                            : ""
                                            }`}
                                    >
                                        <input
                                            onChange={(e) => setPassword(e.target.value)}
                                            type={showEye ? "text" : "password"}
                                            placeholder="Enter your password"
                                            required
                                        />
                                        {showEye ? (
                                            <svg
                                                onClick={() => {
                                                    setshowEye(!showEye);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 576 512"
                                            >
                                                <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                                            </svg>
                                        ) : (
                                            <svg
                                                onClick={() => {
                                                    setshowEye(!showEye);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 640 512"
                                            >
                                                <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" />
                                            </svg>
                                        )}
                                    </div>

                                    <div
                                        className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError ||
                                            passwordMatchingError ||
                                            passwordLengthError
                                            ? Classes.inputError
                                            : ""
                                            }`}
                                    >
                                        <input
                                            onChange={(e) => setconfirmPassword(e.target.value)}
                                            type={showEye2 ? "text" : "password"}
                                            placeholder="Confirm password"
                                            required
                                        />
                                        {showEye2 ? (
                                            <svg
                                                onClick={() => {
                                                    setshowEye2(!showEye2);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 576 512"
                                            >
                                                <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                                            </svg>
                                        ) : (
                                            <svg
                                                onClick={() => {
                                                    setshowEye2(!showEye2);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 640 512"
                                            >
                                                <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" />
                                            </svg>
                                        )}
                                    </div>

                                    <p className={Classes.signupLink} style={{ maxWidth: "100%" }}>
                                        By creating an account, you agree to the
                                        <a
                                            href="/privacy-policy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <button type="button" className={Classes.linkButton}>
                                                {" "}
                                                Privacy Policy{" "}
                                            </button>
                                        </a>
                                        <span> and </span>
                                        <a
                                            href="/terms-of-service"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <button type="button" className={Classes.linkButton}>
                                                {" "}
                                                Terms of Service{" "}
                                            </button>
                                        </a>
                                    </p>

                                    <button
                                        type="submit"
                                        className={`${Classes.button} ${Classes.signInButton}`}
                                        disabled={loading}
                                    >
                                        Create an account
                                        {loading && <LoadingSpinner />}
                                    </button>

                                    <p className={Classes.signupLink2}>
                                        Have an account?
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigateTo("/login");
                                            }}
                                            className={Classes.linkButton}
                                        >
                                            Sign in
                                        </button>
                                    </p>
                                </form>
                            </motion.div>
                        )}

                        {/* VERIFY */}
                        {state === "verify" && (
                            <motion.div
                                key='verify'
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{
                                    duration: 0.5,
                                    ease: easeOut,
                                    delay: 0.3
                                }}
                            >
                                <form onSubmit={onCLickVerify} className={Classes.signUpInnerCon}>
                                    <div onClick={() => { navigateTo('/') }} className={Classes.miniLogo2} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                                        <div className='logo' >
                                            <img src='/assets/images/logo.png' alt='logo' />
                                        </div>
                                    </div>
                                    <h1 className={Classes.heading2}>Enter verification code</h1>
                                    {codeSentMsg && <p className={Classes.subtitle} style={{ textAlign: 'start' }} > A code was sent to your email </p>}
                                    <br />
                                    <input
                                        onChange={(e) => setUserCode(e.target.value)}
                                        type="number"
                                        value={userCode}
                                        placeholder="Enter your code here"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    {IncorrectCode && <p className={Classes.error}>*Incorrect code.</p>}
                                    <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                                        Verify
                                        {loading && <LoadingSpinner />}
                                    </button>
                                    <p className={Classes.signupLink2}>
                                        Haven't received the code?
                                        <button type="button" onClick={() => switchToVerify()} className={Classes.linkButton}>
                                            Resend code
                                        </button>
                                    </p>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </form>
                            </motion.div>
                        )}

                    </AnimatePresence>
                </div>

                {/* RIGHT SIDE */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, ease: easeOut }}
                    className={Classes.signUpGridRight}
                >
                    <motion.div
                        initial={{ opacity: 0, x: 10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, ease: easeOut, delay: 0.3 }}
                        className={Classes.signUpInnerCon2}
                    >
                        <h5 className={Classes.title3}>Why Partner With Us</h5>
                        <br />

                        <div className={Classes.infoElem}>
                            <div className={Classes.infoImgBox}>
                                <img src="/assets/icons/signup1.png" draggable={false} alt="" />
                            </div>
                            <div className={Classes.infoElemRight}>
                                <h5 className={Classes.title5}>Global Exposure</h5>
                                <h5 className={Classes.miniText2}>
                                    Feature your lighting products to a worldwide network of
                                    architects, designers, and industry professionals.
                                </h5>
                            </div>
                        </div>

                        <div className={Classes.infoElem}>
                            <div className={Classes.infoImgBox}>
                                <img src="/assets/icons/signup2.png" draggable={false} alt="" />
                            </div>
                            <div className={Classes.infoElemRight}>
                                <h5 className={Classes.title5}>Data-Driven Insights</h5>
                                <h5 className={Classes.miniText2}>
                                    Access detailed analytics on product views, clicks, downloads,
                                    and customer engagement trends.
                                </h5>
                            </div>
                        </div>

                        <div className={Classes.infoElem}>
                            <div className={Classes.infoImgBox}>
                                <img src="/assets/icons/signup3.png" draggable={false} alt="" />
                            </div>
                            <div className={Classes.infoElemRight}>
                                <h5 className={Classes.title5}>Effortless Upload Process</h5>
                                <h5 className={Classes.miniText2}>
                                    Feature your lighting products to a worldwide network of
                                    architects, designers, and industry professionals.
                                </h5>
                            </div>
                        </div>

                        <div className={Classes.infoElem}>
                            <div className={Classes.infoImgBox}>
                                <img src="/assets/icons/signup4.png" draggable={false} alt="" />
                            </div>
                            <div className={Classes.infoElemRight}>
                                <h5 className={Classes.title5}>Showcase Your Brand</h5>
                                <h5 className={Classes.miniText2}>
                                    Maintain and display your entire product line in one
                                    professional, searchable profile.
                                </h5>
                            </div>
                        </div>
                    </motion.div>
                    <img
                        src="/assets/images/auth-bg.png"
                        alt=""
                        aria-hidden="true"
                        className={Classes.authBg}
                        draggable={false}
                    />
                </motion.div>
            </div>
        </>
    );
}

export default ManufacturerSignup;